import React from 'react';

const SimpleHero = () => {
  return (
    <div style={{ 
      background: 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)', 
      minHeight: '100vh', 
      display: 'flex', 
      alignItems: 'center', 
      justifyContent: 'center',
      color: 'white',
      textAlign: 'center',
      padding: '20px'
    }}>
      <div>
        <h1 style={{ fontSize: '3rem', marginBottom: '20px' }}>
          Meet Your AI-Powered Weight Loss Companion
        </h1>
        <p style={{ fontSize: '1.25rem', marginBottom: '30px', maxWidth: '600px' }}>
          SlimBuddy uses cutting-edge AI to help you track calories, optimize workouts, 
          and achieve your weight loss goals with personalized guidance every step of the way.
        </p>
        <button 
          style={{
            padding: '15px 30px',
            backgroundColor: '#fff',
            color: '#667eea',
            border: 'none',
            borderRadius: '10px',
            fontSize: '1.1rem',
            fontWeight: '600',
            cursor: 'pointer'
          }}
          onClick={() => window.open('https://apps.apple.com/app/slimbuddy', '_blank')}
        >
          Download on App Store
        </button>
      </div>
    </div>
  );
};

export default SimpleHero;